import { useLocalStorage } from "./useLocalStorage";

const tableKeys = [
  "notice-table",
  "user-management-table",
  "my-bids-table",
  "partner-competitor-table",
  "buyer-details-procurement-table",
  "buyer-list-table",
  "relevant-buyers-table",
  "buyer-table",
  "framework-buyers-table",
  "document-table",
  "pending-document-table",
  "framework-table",
  "notice-analysis-by-group-table",
  "opportunities-table",
  "organisation-search-table",
  "relationships-profiles-buyer-table",
  "notices-table",
  "supplier-table",
  "transactions-table",
  "spend-data-table",
  "suppliers-table",
  "credits-table",
  "admin-user-list-table",
  "contacts-table",
  "buyer-details-contacts-table",
  "related-contacts-table",
  "contacts-search-table",
] as const;
export type TableKey = (typeof tableKeys)[number];

export function useTablePageSize(
  tableKey: TableKey,
  defaultPageSize?: number,
): [number, (pageSize: number) => void] {
  const defaultPageSizes = Object.fromEntries(
    tableKeys.map((key) => [key, key === tableKey && defaultPageSize ? defaultPageSize : 10]),
  ) as Record<TableKey, number>;

  const [pageSizes, setPageSizes] = useLocalStorage<Record<TableKey, number>>(
    "tablePageSizes",
    defaultPageSizes,
  );

  const setPageSize = (pageSize: number) => {
    setPageSizes((prev) => ({
      ...prev,
      [tableKey]: pageSize,
    }));
  };

  const pageSize = pageSizes[tableKey] || defaultPageSizes[tableKey];

  return [pageSize, setPageSize];
}
